<script setup lang="ts">
import { defineAsyncComponent, ref, onMounted } from 'vue'

/* Components */
const FooterLinksDownloadButton = defineAsyncComponent(
  () => import('@/components/Footer/FooterLinksDownloadButton.vue'),
)
const FooterLinksInformation = defineAsyncComponent(
  () => import('@/components/Footer/FooterLinksInformation.vue'),
)
const FooterLinkCompany = defineAsyncComponent(
  () => import('@/components/Footer/FooterLinkCompany.vue'),
)
const FooterLinkSupport = defineAsyncComponent(
  () => import('@/components/Footer/FooterLinkSupport.vue'),
)
const FooterLinksForClients = defineAsyncComponent(
  () => import('@/components/Footer/FooterLinksForClients.vue'),
)
const FooterLinksApp = defineAsyncComponent(
  () => import('@/components/Footer/FooterLinksApp.vue'),
)

const { isDesktop, isMobile, isTablet } = useDevice()

export interface LinkList {
  isClientLinksShow: boolean
  isSupportLinkShow: boolean
  isCompanyLinkShow: boolean
  isInfoLinkShow: boolean
}

const linkList = ref({
  isClientLinksShow: false,
  isSupportLinkShow: false,
  isCompanyLinkShow: false,
  isInfoLinkShow: false,
}) as Ref<LinkList>

onMounted(() => {
  if (isDesktop) {
    Object.keys(linkList.value).map((key: string) => {
      return (linkList.value[key as keyof LinkList] = true)
    })
  }
})

const showLinkList = (listKey: keyof LinkList) => {
  if (isDesktop) return

  linkList.value[listKey] = !linkList.value[listKey]
}
</script>

<template>
  <section class="footer__container-links links">
    <div v-if="!isDesktop" class="links__item">
      <footer-links-download-button
        :is-mobile-download-button="isMobile"
        :is-tablet-download-button="isTablet"
      />
    </div>
    <div class="links__item">
      <span
        class="links__item-headline"
        @click="showLinkList('isClientLinksShow')"
      >
        Клиентам
        <nuxt-img
          v-if="!isDesktop"
          :class="{ 'image--reverse': linkList.isClientLinksShow }"
          alt="Ссылки для клиентов"
          src="/arrow-down.svg"
          width="7"
          height="5"
          loading="lazy"
        />
      </span>

      <footer-links-for-clients
        v-if="linkList.isClientLinksShow"
        class="links__item-list"
      />
    </div>
    <div class="links__item">
      <span
        class="links__item-headline"
        @click="showLinkList('isSupportLinkShow')"
      >
        Поддержка
        <nuxt-img
          v-if="!isDesktop"
          :class="{ 'image--reverse': linkList.isSupportLinkShow }"
          src="/arrow-down.svg"
          width="7"
          height="5"
          alt="Ссылки поддержки"
          loading="lazy"
        />
      </span>

      <footer-link-support v-if="linkList.isSupportLinkShow" />
    </div>
    <div class="links__item">
      <span
        class="links__item-headline"
        @click="showLinkList('isCompanyLinkShow')"
      >
        Компания
        <nuxt-img
          v-if="!isDesktop"
          :class="{ 'image--reverse': linkList.isCompanyLinkShow }"
          src="/arrow-down.svg"
          width="7"
          height="5"
          alt="Ссылки компании"
          loading="lazy"
        />
      </span>

      <footer-link-company v-if="linkList.isCompanyLinkShow" />
    </div>
    <div class="links__item">
      <span
        class="links__item-headline"
        @click="showLinkList('isInfoLinkShow')"
      >
        Информация
        <nuxt-img
          v-if="!isDesktop"
          :class="{ 'image--reverse': linkList.isInfoLinkShow }"
          src="/arrow-down.svg"
          width="7"
          height="5"
          alt="Ссылки для информативности"
          loading="lazy"
        />
      </span>

      <footer-links-information v-if="linkList.isInfoLinkShow" />
    </div>
    <div v-if="isDesktop" class="links__item">
      <span class="links__item-headline">Наше приложение</span>

      <footer-links-app />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.links {
  display: grid;
  grid-template-columns: 170px 170px 270px 270px 170px;
  gap: 0 36px;
  justify-content: space-between;
  width: 100%;
  padding: 40px 0;
  border-bottom: 1px solid $carousel-dot-background;

  &__item {
    width: 100%;
    &-headline {
      display: block;
      margin: 0 0 20px;
      font-size: 16px;
      font-weight: 900;
      line-height: 20px;
      color: #555a6a;
    }
  }

  .image--reverse {
    transform: rotate(180deg);
  }

  @include media('<=desktop-mini') {
    display: grid;
    grid-template-columns: 1fr;
    gap: 40px 0;
    &__item {
      &-headline {
        display: flex;
        align-items: center;
        margin: 0;
        img {
          margin-left: 10px;
        }
      }
      &-list {
        margin-top: 20px;
      }
    }
  }
}
</style>
